import React from 'react';

import { Box } from '@rover/kibble/core';
import { RoverLoading } from '@rover/react-lib/src/components';

const FullPageLoading = (): JSX.Element => {
  return (
    <RoverLoading isLoading data-testid="full-page-loading">
      <Box minHeight="100vh" />
    </RoverLoading>
  );
};

export default FullPageLoading;
